/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccessibleTargetResponse } from '../models/AccessibleTargetResponse';
import type { AccessibleTeamMemberResponse } from '../models/AccessibleTeamMemberResponse';
import type { Shift } from '../models/Shift';
import type { ShiftHistory } from '../models/ShiftHistory';
import type { ShiftOptions } from '../models/ShiftOptions';
import type { ShiftsResponse } from '../models/ShiftsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShiftsService {
    /**
     * Get shifts
     * Get shifts for the team. The shifts can be retrieved only for the team that the user is a member of.
     * @returns ShiftsResponse Shifts retrieved
     * @throws ApiError
     */
    public static getShifts({
        startedAfter,
        endBefore,
    }: {
        startedAfter?: string,
        endBefore?: string,
    }): CancelablePromise<ShiftsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/shifts',
            query: {
                'startedAfter': startedAfter,
                'endBefore': endBefore,
            },
        });
    }
    /**
     * Create a new shift
     * Create a new shift for the team. The shift can be created only for the team that the user is a member of.
     * @returns Shift Shift created
     * @throws ApiError
     */
    public static createShift({
        requestBody,
    }: {
        requestBody: ShiftOptions,
    }): CancelablePromise<Shift> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/shifts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Shift conflict detected`,
            },
        });
    }
    /**
     * Delete a shift
     * Delete a shift for the team. The shift can be deleted only for the team that the user is a member of.
     * @returns void
     * @throws ApiError
     */
    public static deleteShift({
        shiftId,
    }: {
        shiftId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/shifts/{shiftId}',
            path: {
                'shiftId': shiftId,
            },
        });
    }
    /**
     * Update a shift
     * Update a shift for the team. The shift can be updated only for the team that the user is a member of.
     * @returns Shift Shift updated
     * @throws ApiError
     */
    public static updateShift({
        shiftId,
        requestBody,
    }: {
        shiftId: number,
        requestBody: ShiftOptions,
    }): CancelablePromise<Shift> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dashboard/api/v1/shifts/{shiftId}',
            path: {
                'shiftId': shiftId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Shift conflict detected`,
            },
        });
    }
    /**
     * @returns AccessibleTargetResponse OK
     * @throws ApiError
     */
    public static accessibleTargets({
        target,
        id,
    }: {
        target: 'Creator' | 'TeamMember',
        id: number,
    }): CancelablePromise<AccessibleTargetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/shifts/{target}/{id}',
            path: {
                'target': target,
                'id': id,
            },
        });
    }
    /**
     * Get shifts history
     * Get shifts history for the team. The shifts history can be retrieved only for the team that the user is a member of.
     * @returns ShiftHistory Shifts history retrieved
     * @throws ApiError
     */
    public static getShiftsHistory({
        startDate,
        endDate,
    }: {
        startDate: string,
        endDate: string,
    }): CancelablePromise<Array<ShiftHistory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/shifts/history',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
    /**
     * Get accessible team members
     * Get accessible team members for the user.
     * @returns AccessibleTeamMemberResponse Accessible team members retrieved
     * @throws ApiError
     */
    public static accessibleTeamMembers({
        creatorIds,
    }: {
        creatorIds: Array<number>,
    }): CancelablePromise<AccessibleTeamMemberResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/shifts/accessible-team-members',
            query: {
                'creatorIds': creatorIds,
            },
        });
    }
}
